var tabsClickCountForScroll = 0;

$.fn.tabs = function () {
  var main = $(this);
  var anchors = main.find('[data-anchor]');
  
  var tabs = main.find('[data-tab]');
  anchors.each(function () {
    $(this).attr('data-anchor', slug($(this).attr('data-anchor')));
  });
  tabs.each(function () {
    $(this).attr('data-tab', slug($(this).attr('data-tab')));
  });
  anchors.on('click', function (e) {
    e.preventDefault();
    showTab($(this).data('anchor'));
    scrollToTab();
  }).eq(0).trigger('click');
  
  function scrollToTab() {
    tabsClickCountForScroll += 1;
    if ((tabsClickCountForScroll > 1) && $(".tabs__title").is(":visible")) {
      if ($(".tabs__button--active:visible").offset()) {
        let header = $(".header-mobile ").outerHeight() ?? 0;
        let scrollToItem = $(".tabs__button--active:visible").offset().top - header;
        if ($(document).scrollTop() > scrollToItem) {
          $(document).scrollTop(scrollToItem);
        }
      }
    }
  };

  function showTab(slug) {
    const tab = tabs.filter("[data-tab=\"".concat(slug, "\"]"))
    const isVisible = tab.is(':visible');
    tabs.hide();
    if (!isVisible) {
      tab.show();
    }

    anchors.removeClass('tabs__button--active');
    if (!isVisible) {
      anchors.filter("[data-anchor=\"".concat(slug, "\"]")).addClass('tabs__button--active');
    }
  }
};
